export default "__VITE_ASSET__6aUk1Lvi__"